// extracted by mini-css-extract-plugin
export default {"wrapper":"Login_wrapper__mzl4-","container":"Login_container__eleHa","content":"Login_content__fFSd2"};